import { useEffect, useRef } from 'react'
import { useProfessional } from '../../../context/ProfessionalContext'
import Notes from '../../Professional/Detail/Tabs/Notes'
import { useAuth } from '../../../context/AuthContext'

export default function OpenNotes() {
    const { user } = useAuth()
    const { detail, getProfessional } = useProfessional()
    const hasFetched = useRef(false)

    useEffect(() => {
        if (user?.userID && !hasFetched.current) {
            hasFetched.current = true
            getProfessional(String(user.userID))
        }
    }, [user?.userID])

    if (!detail) {
        return <p className='text-center text-sm opacity-80 animate-pulse dark:text-gray-200'>Carregando notas...</p>
    }

    return (
        <div className='dark:text-gray-200'>
            <Notes title='Minhas notas abertas' status={0} />
        </div>
    )
}
